import { Settings } from '../models/settings';
import { InjectionToken } from '@angular/core';

export let SettingService = new InjectionToken<Settings>('/assets/settings.json');